// Events on the web — the same endpoints the app's Events tab uses.
import { api, qs } from "@/lib/api";

export const EVENT_CATEGORIES = [
  { key: "", label: "All" },
  { key: "music", label: "Music" },
  { key: "club", label: "Club" },
  { key: "comedy", label: "Comedy" },
  { key: "theatre", label: "Theatre" },
  { key: "food", label: "Food" },
  { key: "sport", label: "Sport" },
  { key: "workshop", label: "Workshop" },
  { key: "talk", label: "Talk" },
  { key: "community", label: "Community" },
  { key: "other", label: "Other" },
];

export const eventsApi = {
  discover: (params) => api(`/events/discover?${qs(params)}`),
  get: (id) => api(`/events/${id}`),
  attendees: (id) => api(`/events/${id}/attendees`),
  feePreview: (params) => api(`/events/fee-preview?${qs(params)}`),
  hold: (id, items, extra = {}) => api(`/events/${id}/hold`, { method: "POST", body: { items, ...extra } }),
  dropHold: (holdId) => api(`/events/holds/${holdId}`, { method: "DELETE" }),
  checkout: (holdId, body) => api(`/events/holds/${holdId}/checkout`, { method: "POST", body }),
  orderBySession: (sid) => api(`/events/orders/by-session/${encodeURIComponent(sid)}`),
  abandonOrder: (orderId) => api(`/events/orders/${orderId}/abandon`, { method: "POST" }),
  myTickets: () => api("/events/tickets/mine"),
  myOrders: () => api("/events/orders/mine"),
  calendarUrl: (id) => `${process.env.REACT_APP_BACKEND_URL}/api/events/${id}/calendar.ics`,
};

export function pence(p) {
  const n = Number(p || 0) / 100;
  return `£${n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)}`;
}

/** Format an ISO timestamp in the offset it was written in (the venue's local time), not the browser's. */
export function venueTime(iso, opts = {}) {
  if (!iso) return "";
  const m = /([+-]\d{2}):?(\d{2})$/.exec(iso);
  const offsetMin = m ? (Number(m[1]) * 60 + Math.sign(Number(m[1]) || 1) * Number(m[2])) : 0;
  const d = new Date(iso);
  const shifted = new Date(d.getTime() + offsetMin * 60000);
  const { date = true, time = true, weekday = true } = opts;
  const parts = [];
  if (date) parts.push(shifted.toLocaleDateString("en-GB", { timeZone: "UTC", weekday: weekday ? "short" : undefined, day: "numeric", month: "short" }));
  if (time) parts.push(shifted.toLocaleTimeString("en-GB", { timeZone: "UTC", hour: "2-digit", minute: "2-digit" }));
  const tz = m && m[0] !== "+00:00" && m[0] !== "Z" ? ` (UTC${m[1]}:${m[2]})` : "";
  return parts.join(" · ") + (time ? tz : "");
}
